import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GungModalService } from 'gung-standard';

@Component({
    selector: 'tylo-tylo-export-quotation-modal',
    templateUrl: './tylo-export-quotation-modal.component.html',
    styleUrl: './tylo-export-quotation-modal.component.css',
    standalone: false
})
export class TyloExportQuotationModalComponent {

  email = '';

  componentId: string;
  additionalInfo = '';

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
    this.componentId = TyloExportQuotationModalComponent.name;
  }

  confirm() {

    this.activeModal.close({ email: this.email, additionalInfo: this.additionalInfo });
  }

  cancel() {
    this.activeModal.close({ email: '' });
  }

}
